import {
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import { useGetFarmersQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import CustomSearchBar from "components/CustomSearchBar";
import ListViewActionItems from "components/ListViewActionItems";
import ListViewContainer from "components/ListViewContainer";
import { selectCurrentUser } from "features/auth/authSlice";
import { useEffect, useState } from "react";
import { Col, Row, ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { CardHeader, Button } from "reactstrap";
import { UpdateAggregationDetails } from "./UpdateAggregationDetails";
import { useCreateAggregationFarmerStockMutation } from "./AggregationApiSlice";
import { toast } from "react-toastify";

const AggregationAssignFarmer = ({
  aggregationDetails,
  setAddFarmer,
  refetchFarmers,
}) => {
  const orgId = "";
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [farmers, setFarmers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0,per_page:50 });
  const [stateId, setStateId] = useState("null");
  const [districtId, setDistrictId] = useState("null");
  const [searchKey, setSearchKey] = useState("");
  const [gender, setGender] = useState("");
  const [farmerCategory, setFarmerCategory] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { data: data, isLoading, isFetching, refetch } = useGetFarmersQuery(
    {
      orgId,
      page: pagination.page,
      per_page: pagination.per_page,
      stateId,
      districtId,
      searchKey: debouncedSearch || "",
      farmerCategory,
      gender,
    },
    { refetchOnMountOrArgChange: true }
  );
  const [addFarmerStock] = useCreateAggregationFarmerStockMutation();

  const { data: getStates } = useGetStatesQuery();
  const canCall = { stateId: stateId, districtId: districtId };
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !canCall.stateId,
  });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [selectedFarmers, setSelectedFarmers] = useState({});
  const [step, setStep] = useState(1);
  const [farmersDetails, setfarmersDetails] = useState({});
  const [farmerInputs, setFarmerInputs] = useState({});

  const handleCheckboxChange = (event, row) => {
    let updatedSelection;
    setSelectedFarmers((prevSelected) => {
      updatedSelection = { ...prevSelected };
      if (event.target.checked) {
        updatedSelection[row.id] = row;
      } else {
        delete updatedSelection[row.id];
      }

      return updatedSelection;
    });
    // localStorage.setItem(
    //   "selectedFarmers",
    //   JSON.stringify(updatedSelection || {})
    // );
  };
  useEffect(() => {
    // const savedFarmers =
    //    JSON.parse(localStorage.getItem("selectedFarmers")) || {};
    // setfarmersDetails(savedFarmers);
       setfarmersDetails(selectedFarmers);

  }, [selectedFarmers]);
  // useEffect(() => {
  //   const savedFarmers = JSON.parse(localStorage.getItem("selectedFarmers")) || {};
  //   const farmerArray = Object.values(savedFarmers);
  //   setfarmersDetails(farmerArray);
  // }, [selectedFarmers]);

  const columns = [
    {
      field: "selectFarmer",
      headerName: "Select",
      width: 90,
      renderCell: (cellValues) => (
        <div>
          <input
            type="checkbox"
            checked={!!selectedFarmers[cellValues.row.id]}
            onChange={(e) => handleCheckboxChange(e, cellValues.row)}
            className="mx-3"
          />
        </div>
      ),
    },
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Onboarding Date",
      width: 150,
      renderCell: (cellvalues) => {
        return (
          <div>
            {" "}
            {cellvalues.row.created_at
              ? cellvalues.row.created_at.slice(0, 10)
              : ""}{" "}
          </div>
        );
      },
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    {
      field: "age",
      headerName: "Age",
      width: 50,
      headerAlign: "center",
      align: "center",
    },

    // { field: "farmer_category", headerName: "Farmer Category", width: 220 },
    {
      field: "farmer_category",
      headerName: "Category",
      width: 200,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",

            fontSize: "14px",
          }}
          title={cellValues?.row?.farmer_category || ""}
        >
          {(cellValues?.row?.farmer_category || "").length > 50
            ? `${cellValues?.row?.farmer_category.substring(0, 50)}...`
            : cellValues?.row?.farmer_category || ""}
        </div>
      ),
    },

    {
      field: "total_land_holding",
      headerName: "Landholding",
      width: 110,
      renderCell: (cellvalues) => {
        return (
          <div>
            {cellvalues.row.total_land_holding} &nbsp;
            {cellvalues.row.unit_of_land_holding}
          </div>
        );
      },
    },

    {
      field: "total_acs",
      headerName:
        RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV")
          ? "Farm Score"
          : "ACS",
      width: 100,
      renderCell: (cellvalues) => {
        return <div>{cellvalues.row.total_acs.toFixed(2)}</div>;
      },
    },

    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "140px",
            fontSize: "13px",
          }}
          title={cellValues?.row?.district_name || ""}
        >
          {(cellValues?.row?.district_name || "").length > 50
            ? `${cellValues?.row?.district_name.substring(0, 50)}...`
            : cellValues?.row?.district_name || ""}
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (data != undefined) {
      const paginationFromApi = data?.data?.pages
        ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
        : pagination;
      setFarmers(data?.data?.results);
      setPagination(paginationFromApi);
    }
  }, [data]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px",
      height: "35px",
      padding: "0px",
      fontSize: "13px",
      zIndex: 1000,
    }),
  };
  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const onLocationChange = (event) => {
    setPagination({ page: 1, pageCount: 0 });
    if (event.ConditionName == "state") {
      setDistrictName("");
      setDistrictId("null");
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
    }
  };
  useEffect(() => {
    if (stateId !== "" || districtId !== "") {
      refetch();
    }
  }, [stateId, districtId]);
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (message) => {
    setPagination({ page: 1, pageCount: 0 });
    setSearchKey(message);
  };
  const handleNext = () => {
    setStep((prev) => Math.min(prev + 1, 3));
  };
  const handleBack = () => setStep((prev) => Math.max(prev - 1, 1));

  const progressVariant =
    step === 1 ? "info" : step === 2 ? "warning" : "success";
  const progressNow = step === 1 ? 30 : step === 2 ? 70 : 100;
  const progressLabel =
    step === 1
      ? `Step 1: Select Farmers for Crop ${aggregationDetails.crop_name}`
      : step === 2
      ? `Step 2: Enter Farmer Details for Crop ${aggregationDetails.crop_name}`
      : "Step 3: Submit";

  const handleSubmit = () => {
    const farmersArray = Object.values(farmerInputs);
    console.log("farmerInputs", farmersArray);
    if (farmersArray?.length !== 0) {
      addFarmerStock(farmersArray)
        .unwrap()
        .then((data) => {
          toast.success("Farmer Stock Created");
          refetchFarmers();
          // localStorage.removeItem("selectedFarmers");
          setAddFarmer(false);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  return (
    <>
      <div className="mb-3">
        <ProgressBar
          now={progressNow}
          label={progressLabel}
          animated
          striped
          variant={progressVariant}
          style={{ height: "25px", fontWeight: 600, fontSize: "14px" }}
        />
      </div>

      <h5 className="mb-3">{progressLabel}</h5>
      {step === 1 && (
        <>
          <Row className="mt-1 px-1 mb-2">
            <Col
              xs="12"
              md="6"
              lg="2"
              className="d-flex  justify-content-start"
            >
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>

            <Col xs="5" md="6" lg="2" className="offset-md-3">
              <div className="mt-2 d-flex justify-content-end">
                {" "}
                Total Farmers :
                <span className="text-success">&nbsp;{data?.data?.total}</span>
              </div>
            </Col>
            <Col xs="7" md="6" lg="5" className="d-flex justify-content-end">
              <ListViewActionItems
                orgId={orgId}
                refetch={refetch}
                RoleAcessParams={RoleAcessParams}
                currentUser={currentUser}
                farmers={farmers}
                stateId={stateId}
                districtId={districtId}
                blockId=""
                searchKey={searchKey}
                farmerCategory={farmerCategory}
                gender={gender}
                setPagination={setPagination}
                showFields={false}
              />
            </Col>
          </Row>
          <CardHeader>
            <Row className="mt-3">
              <Col lg="9" className="d-flex gap-2 ">
                <Col sm="2" className="mb-2 position-relative">
                  <Select
                    menuPlacement="auto"
                    options={handleStateOptions()}
                    placeholder={stateId == "null" ? "State" : stateName}
                    value={stateId === "null" ? "Select State" : stateName}
                    onChange={onLocationChange}
                    styles={customStyles}
                  />
                  {stateId !== "null" && (
                    <span
                      className="clear-icon"
                      onClick={() => {
                        setStateId("null");
                        setStateName("null");
                      }}
                      style={{
                        position: "absolute",
                        top: "60%",
                        right: "60px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "12px",
                        zIndex: 1000,
                      }}
                    >
                      ✕
                    </span>
                  )}
                </Col>

                <Col sm="2" className="mb-2 position-relative">
                  <Select
                    menuPlacement="auto"
                    options={handleDistrictOptions()}
                    placeholder={
                      districtId === "null" ? "District" : districtName
                    }
                    value={
                      districtId === "null" ? "Select District" : districtName
                    }
                    onChange={onLocationChange}
                    styles={customStyles}
                  />
                  {districtId !== "null" && (
                    <span
                      className="clear-icon"
                      onClick={() => {
                        setDistrictId("null");
                        setDistrictName("null");
                      }}
                      style={{
                        position: "absolute",
                        top: "60%",
                        right: "60px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "12px",
                        zIndex: 1000,
                      }}
                    >
                      ✕
                    </span>
                  )}
                </Col>

                <Col sm="2" className="mb-2 position-relative">
                  <Select
                    menuPlacement="auto"
                    options={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                      { value: "Others", label: "Others" },
                    ]}
                    placeholder={gender === "" ? "Gender" : gender}
                    value={gender === "" ? "Gender" : gender}
                    onChange={(selected) => {
                      setGender(selected?.value || null);
                      setPagination({ page: 1, pageCount: 0 });
                    }}
                    styles={customStyles}
                  />
                  {gender && (
                    <span
                      className="clear-icon"
                      onClick={() => setGender("")}
                      style={{
                        position: "absolute",
                        top: "60%",
                        right: "60px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "12px",
                        zIndex: 1000,
                      }}
                    >
                      ✕
                    </span>
                  )}
                </Col>
                <Col sm="3" className="mb-2 position-relative">
                  <Select
                    menuPlacement="auto"
                    options={[
                      {
                        value: "Marginal (Less than 2.5 acres)",
                        label: "Marginal (Less than 2.5 acres)",
                      },
                      {
                        value: "Small (2.5–5 acres)",
                        label: "Small (2.5–5 acres)",
                      },
                      {
                        value: "Semi Medium (5–10 acres)",
                        label: "Semi Medium (5–10 acres)",
                      },
                      {
                        value: "Medium (10–25 acres)",
                        label: "Medium (10–25 acres)",
                      },
                      {
                        value: "Large (25 acres and above)",
                        label: "Large (25 acres and above)",
                      },
                    ]}
                    placeholder={
                      farmerCategory === "" ? "Category" : farmerCategory
                    }
                    value={farmerCategory === "" ? "Category" : farmerCategory}
                    onChange={(selected) => {
                      setFarmerCategory(selected?.value || null);
                      setPagination({ page: 1, pageCount: 0 });
                    }}
                    styles={customStyles}
                  />
                  {farmerCategory && (
                    <span
                      className="clear-icon"
                      onClick={() => setFarmerCategory("")}
                      style={{
                        position: "absolute",
                        top: "60%",
                        right: "60px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "12px",
                        zIndex: 1000,
                      }}
                    >
                      ✕
                    </span>
                  )}
                </Col>
              </Col>
              <Col md={{ span: 3 }} className="text-end">
                <Button
                  id="AddLeads"
                  className="primary"
                  size="sm"
                  onClick={handleNext}
                >
                  Next&nbsp;
                </Button>
              </Col>
            </Row>
          </CardHeader>

          <div className="d-lg-block d-md-block d-none">
            <ListViewContainer
              showHeaderSection={true}
              searchBar={true}
              tableData={{
                rows: farmers,
                columns: columns,
                paginationState: [pagination, setPagination],
                isLoading: isLoading || isFetching,
                checkboxShowFalse: true,
              }}
            />
          </div>
        </>
      )}
      {step === 2 && (
        <div className=" align-items-end">
          {/* <Button variant="secondary" onClick={handleBack}>
            Back
          </Button> */}
          <UpdateAggregationDetails
            savedFarmers={farmersDetails}
            handleNext={handleNext}
            setSelectedFarmers={setSelectedFarmers}
            aggregationDetails={aggregationDetails}
            setFarmerInputs={setFarmerInputs}
            farmerInputs={farmerInputs}
            handleBack={handleBack}
          />
        </div>
      )}
      {step === 3 && (
        <>
          <div className="text-end mb-3">
            <Button color="primary" size="sm" onClick={handleSubmit}>
              Submit
            </Button>
            {/* <Button  size="sm" onClick={handleBack}>
                    Back
                  </Button> */}
          </div>
          <div className="alert alert-success text-center">
            <h5>Submit</h5>
            <p className="mt-2">
              Please go to <strong>Submit Button</strong> to add Farmers.
            </p>
          </div>
        </>
      )}
    </>
  );
};
export default AggregationAssignFarmer;
